import React from 'react';
import './Healthcare.css';

const Healthcare = () => {
  return (
    <div className="healthcare-container">
      <img src="/images/health.png" alt="Health" className="healthcare-banner" />
      
      <h1 className="title">Healthcare and Life Sciences Solutions</h1>
      <p className="intro">
        At Inovaantage, we deliver cutting-edge solutions tailored to meet the dynamic needs of the healthcare and life sciences industries. Our expertise empowers organizations to optimize processes, enhance patient care, and drive innovation.
      </p>

      <section className="service-section">
        <h2>Our Key Services</h2>

        <div className="service-block">
          <h3>Digital Transformation in Healthcare</h3>
          <ul>
            <li>Advanced health IT systems (EHR/EMR solutions).</li>
            <li>Cloud-based infrastructure for data access & management.</li>
            <li>AI/ML integration for predictive analytics & insights.</li>
          </ul>
        </div>

        <div className="service-block">
          <h3>Clinical Data Management and Analytics</h3>
          <ul>
            <li>End-to-end clinical trial data management.</li>
            <li>Real-time analytics in drug development.</li>
            <li>Global regulatory compliance support.</li>
          </ul>
        </div>

        <div className="service-block">
          <h3>Healthcare Workflow Automation</h3>
          <ul>
            <li>Administrative task automation.</li>
            <li>AI chatbots for patient engagement.</li>
            <li>Billing and claims management.</li>
          </ul>
        </div>

        <div className="service-block">
          <h3>Telemedicine and Remote Care</h3>
          <ul>
            <li>Secure telemedicine platforms.</li>
            <li>Wearable integration for monitoring.</li>
            <li>Mobile health app development.</li>
          </ul>
        </div>

        <div className="service-block">
          <h3>Pharmaceutical and Biotech Solutions</h3>
          <ul>
            <li>Pharma supply chain optimization.</li>
            <li>Advanced LIMS systems.</li>
            <li>AI for drug discovery.</li>
          </ul>
        </div>

        <div className="service-block">
          <h3>Regulatory Compliance & Risk Management</h3>
          <ul>
            <li>HIPAA, GDPR compliance.</li>
            <li>Risk assessment & mitigation strategies.</li>
            <li>Cybersecurity for patient data.</li>
          </ul>
        </div>
      </section>

      <section className="why-choose">
        <h2>Why Choose Inovaantage?</h2>
        <ul>
          <li>Expertise in cutting-edge technologies.</li>
          <li>Industry-experienced team.</li>
          <li>Proven track record of success.</li>
        </ul>
      </section>

      <p className="closing">
        Partner with Inovaantage to transform your healthcare and life sciences operations into a future-ready, patient-centric model.
      </p>
    </div>
  );
};

export default Healthcare;
